import { SearchableAnalysisInstantSearch } from '@livv/models';
import { completePreviewLink, getDecisionLink } from '@livv/utils/helpers';
import { FC } from 'react';
import ContentCard, { PreviewCardProps } from './ContentCard';
import { APP_URL } from '@utils/consts/livv';
import { getFullTextSearchQuery } from '@utils/search/snippet';

interface AnalysisPreviewProps extends PreviewCardProps<SearchableAnalysisInstantSearch> {
    query: string;
}

const AnalysisPreview: FC<AnalysisPreviewProps> = ({ hit, query }) => {
    const { baseObjectID, decisionId } = hit;
    const baseHref = getDecisionLink(decisionId, baseObjectID);

    return (
        <ContentCard
            hit={hit}
            href={completePreviewLink(baseHref, APP_URL, getFullTextSearchQuery(hit, query))}
            snippetAttribute="fullText"
            subtitleAttributes={[{ attribute: 'subtitle' }]}
            titleAttribute="title"
        />
    );
};

export default AnalysisPreview;
